<template>

	<el-input
		ref="input"
		class="input-sigarus-password"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
		show-password
	/>

</template>

<script>
	export default {
		name: 'InputSigarusText',
		props: {
			value: {
				default: ''
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }

			}

		},
		methods: {
			$render (val) {
				return `<ul class="pasword-points"><li></li><li></li><li></li><li></li><li></li><li></li></ul>`
			},
			
			focus () {
				setTimeout(() => this.$refs.input.focus(), 200)
			},

			select () {
				setTimeout(() => this.$refs.input.select(), 200)
			}
		}
	}
</script>

<style lang="scss">
ul.pasword-points {
    padding: 0px;
    list-style: none;
    display: flex;
    align-items: center;
	height: 20px;
	li {
		width: 5px;
		height: 5px;
		background-color: black;
		border-radius: 50%;
		padding: 0px!important;
		margin-right: 2px;
	}
}
</style>
